import React from 'react'

export const PaperClipIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [maskId] = React.useState(() => `mask0_${Date.now()}`)

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='currentColor' />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d='M17 15.1453C17 16.4917 16.5172 17.6374 15.5515 18.5824C14.586 19.5275 13.4051 20 12.0089 20C10.6127 20 9.42881 19.5275 8.45729 18.5824C7.48576 17.6374 7 16.4917 7 15.1453V7.38467C7 6.44452 7.33656 5.64533 8.00969 4.98711C8.68297 4.32904 9.50892 4 10.4875 4C11.4662 4 12.292 4.32904 12.9652 4.98711C13.6384 5.64533 13.9751 6.44452 13.9751 7.38467V14.7351C13.9751 15.257 13.7855 15.7066 13.4063 16.0838C13.0272 16.461 12.5652 16.6496 12.0202 16.6496C11.4753 16.6496 11.0065 16.4639 10.6138 16.0927C10.2212 15.7214 10.0249 15.2689 10.0249 14.7351V7.35045H10.9502V14.7351C10.9502 15.0188 11.0513 15.2607 11.2534 15.4607C11.4558 15.6607 11.7046 15.7607 11.9999 15.7607C12.2954 15.7607 12.5442 15.6607 12.7463 15.4607C12.9487 15.2607 13.0498 15.0188 13.0498 14.7351V7.36756C13.0463 6.67689 12.7991 6.09111 12.3082 5.61022C11.8175 5.12933 11.2106 4.88889 10.4875 4.88889C9.77 4.88889 9.16357 5.13222 8.66825 5.61889C8.17292 6.10541 7.92526 6.694 7.92526 7.38467V15.1453C7.92172 16.2428 8.31734 17.1781 9.11214 17.9513C9.90679 18.7245 10.8745 19.1111 12.0154 19.1111C13.1399 19.1111 14.0958 18.7245 14.883 17.9513C15.6702 17.1781 16.0675 16.2428 16.0747 15.1453V7.35045H17V15.1453Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
